<template>
	<div class="mzhongBrandCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst" src="../../assets/zhongBrand/banner-chuang.jpg">
			<div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="enterProducts(5)">
					<img class="mFirstBoxImg" src="../../assets/zhongBrand/zhongTopNew.png" alt="">
				</div>
			</div>
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>
		<div class="secondBox">
			<!-- <img class="mFirst2" src="../../assets/zhongBrand/01.jpg" alt=""> -->
			<div class="secondBoxMiddle">
				<div class="secondBoxMiddleItem secondBoxMiddleItem1">
					<img class="secondBoxMiddleItemImg" src="../../assets/zhongBrand/chuang-1.jpg" alt="">
				</div>
				<div class="secondBoxMiddleItem secondBoxMiddleItem1">
					<img class="secondBoxMiddleItemImg" src="../../assets/zhongBrand/chuang-1.jpg" alt="">
				</div>
				<div class="secondBoxMiddleItem secondBoxMiddleItem1">
					<img class="secondBoxMiddleItemImg" src="../../assets/zhongBrand/chuang-1.jpg" alt="">
				</div>
			</div>
		</div>

		<div class="thirdBox">
			<!-- <img class="mFirst3" src="../../assets/zhongBrand/02.jpg" alt=""> -->
			<div class="thirdBoxMain">
				<div class="pageBoxMainLeft3">
					<div class="pageBoxMainLeftTop3">孕育新生，也要守护美丽</div>
					<div class="pageBoxMainLeftRight3">
						<img class="pageBoxMainLeftRightImg3" src="../../assets/zhongBrand/dpBd.png" alt="">
					</div>
				</div>
				<div class="pageBoxMainRight3">
					<img class="pageBoxMainRightImg3" src="../../assets/zhongBrand/jju.png" alt="">
				</div>
			</div>
		</div>

		<div class="forthBox">
			<div class="aboutTitle1">品牌理念</div>
			<wc-swiper class="swiperItemBox">
				<wc-slide v-for="(item,index) in linianData" :key="index">
					<div class="swiperBoxMain">
						<img class="swiperBoxMainImg" :src="item.img" alt="">
					</div>
				</wc-slide>
			</wc-swiper>
			<div class="swiperItemTitle">
				集蕴自然草本菁华，以科学的皮肤知识为指导，悉心呵护宝宝的娇嫩肌肤，为孕妈带去安心的护肤体验。
			</div>
		</div>

		<div class="fifthBox">
			<!-- <img class="mFirst5" src="../../assets/zhongBrand/03.jpg" alt=""> -->
			<div class="fifthBoxMiddle">
				<div class="aboutTitle2">品牌特色</div>
				<div class="fifthBoxMiddleItem">
					<div class="MainItem MainItem1">
						<img class="mainItemImg" src="../../assets/zhongBrand/zhongBottomNew1.png" alt="">
					</div>
					<div class="MainItem MainItem2">
						<img class="mainItemImg" src="../../assets/zhongBrand/zhongBottomNew2.png" alt="">
					</div>
					<div class="MainItem MainItem3">
						<img class="mainItemImg" src="../../assets/zhongBrand/zhongBottomNew3.png" alt="">
					</div>
					<div class="MainItem MainItem4">
						<img class="mainItemImg" src="../../assets/zhongBrand/zhongBottomNew4.png" alt="">
					</div>
				</div>
			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			linianData: [
				{
					id: 1,
					img: require('../../assets/zhongBrand/syBd.png')
				},
				{
					id: 2,
					img: require('../../assets/mImg/mzhongHuai.png')
				}
			],
			drawer: false,
			direction: 'ltr'
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		enterProducts(id) {
			this.$router.push({ path: '/mProductList', query: { brandId: id } });
		},
	}
}
</script>

<style scoped>
.mzhongBrandCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBoxMenu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.mFirstBoxImgMenu {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}



.mFirstBox {
	position: absolute;
	top: 20%;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
}

.mFirstBoxImg {
	width: 45%;
	float: right;
	margin-right: 3%;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}

.secondBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: url(../../assets/zhongBrand/01.jpg) no-repeat;
	background-size: 100%;
}

.secondBoxMiddle {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	position: relative;
	padding-top: 5%;
	padding-bottom: 5%;
}

.secondBoxMiddleItem {
	width: 30%;
}

.secondBoxMiddleItemImg {
	width: 100%;
}

.thirdBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: url(../../assets/zhongBrand/02.jpg) no-repeat;
	background-size: 100%;
}

.thirdBoxMain {
	width: 100%;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	justify-content: center;
	position: relative;
	padding-top: 5%;
	padding-bottom: 5%;
}

.pageBoxMainLeft3 {
	width: 55%;
	display: flex;
	flex-direction: column;
}

.pageBoxMainRightImg3 {
	width: 100%;
}

.pageBoxMainRight3 {
	width: 35%;
	display: flex;
	flex-direction: column;
	z-index: 99;
	position: relative;
	opacity: 1;
	left: -1rem;
}


.pageBoxMainLeftTop3 {
	width: 80%;
	height: 26px;
	border: 1px solid #000000;
	border-radius: 5px;
	text-align: center;
	line-height: 26px;
	font-size: 0.75rem;
	font-weight: bold;
	color: #2A2A2A;
	margin: 0 auto;
}

.pageBoxMainLeftRight3 {
	margin-top: 0.5rem;
	width: 100%;
}

.pageBoxMainLeftRightImg3 {
	width: 100%;
}

.forthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #E8BBC5;
	padding-bottom: 1rem;

}

.aboutTitle1 {
	font-size: 1.4rem;
	color: #000000;
	font-family: simsun;
	line-height: 20px;
	margin-top: 2rem;
}

.aboutTitle2 {
	font-size: 1.2rem;
	color: #000000;
	line-height: 20px;
	position: relative;
	top: -1rem;
}

.swiperBoxMain {
	width: 65%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
	border-radius: 1rem;
}

.swiperBoxMainImg {
	width: 100%;
	border-radius: 1rem;
}

.swiperItemTitle {
	color: #222222;
	font-size: 1rem;
	width: 80%;
	margin: 0 auto;
	text-align: center;
}

.swiperItemBox {
	margin-top: 1rem;
}

.fifthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: url(../../assets/mImg/zhongBottomBd.jpg) no-repeat;
	background-size: 100%;
}


.fifthBoxMiddle {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	padding-top: 13%;
	padding-bottom: 13%;
}

.fifthBoxMiddleItem {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	margin-top: 1rem;
}

.MainItem {
	width: 20%;
}

.mainItemImg {
	width: 100%;
}




.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #FFFFFF;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color: #E8BBC5;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

.mFirst2 {
	width: 100%;
	position: absolute;
}

.mFirst3 {
	width: 100%;
	position: absolute;
}

.mFirst5 {
	width: 100%;
	position: absolute;
}


/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mzhongBrand.vue